import _VisibilityOff from "@material-ui/icons/esm/VisibilityOff";
import _Visibility from "@material-ui/icons/esm/Visibility";
import _InputAdornment from "@material-ui/core/esm/InputAdornment";
import _IconButton from "@material-ui/core/esm/IconButton";
var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import React from 'react';
import PropTypes from 'prop-types';

var _ref = /*#__PURE__*/_jsx(_Visibility, {
  color: "primary",
  fontSize: "small"
});

var _ref2 = /*#__PURE__*/_jsx(_VisibilityOff, {
  fontSize: "small"
});

const PasswordAdornment = props => {
  const fieldStatus = props.fieldStatus,
        onClick = props.onClick,
        onMouseDown = props.onMouseDown;
  return _jsx(_InputAdornment, {
    position: "end"
  }, void 0, _jsx(_IconButton, {
    "aria-label": "toggle password visibility",
    onClick: onClick,
    onMouseDown: onMouseDown,
    edge: "end"
  }, void 0, fieldStatus ? _ref : _ref2));
};

PasswordAdornment.defaultProps = {
  onClick: () => {},
  onMouseDown: () => {},
  fieldStatus: false
};
export { PasswordAdornment };